import { useEffect, useMemo, useState } from 'react'
import { postInfo as postInfoBackend } from './backend'
// SEND TO PARENT
const PARENT_ORIGIN = '*'
const postMessageToParent = (message: any): void => {
  window.parent?.postMessage(message, PARENT_ORIGIN)
}
export const sendAccountKey = (key: string): void => {
  postMessageToParent({
    action: 'saveKey',
    key
  })
}
export const closeChat = () => {
  postMessageToParent({
    action: 'close'
  })
}
export const forceDestroy = (): void => {
  postMessageToParent({
    action: 'destroy'
  })
}
export const signalLoaded = () => {
  postMessageToParent({ action: 'loaded' })
}

const STAY_INTERVAL = 5000
// LISTEN FROM PARENT
export const useListenFromParent = () => {
  const [showChat, setShowChat] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    return !!params.get('defaultShow')
  })
  useEffect(() => {
    const listener = async (event: MessageEvent) => {
      const { data } = event
      switch (data.action) {
        case 'postInfo': {
          postInfoBackend(data.info, 'METADATA')
          break
        }
        case 'updateUserInfo': {
          postInfoBackend(data.userInfo, 'USER_METADATA')
          break
        }
        case 'close': {
          setShowChat(false)
          break
        }
        case 'open': {
          setShowChat(true)
          break
        }
      }
    }
    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [setShowChat])
  return { showChat }
}
